// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ed506ef1","977":"e604d01e"}[chunkId] + ".chunk.js";
};